import { defineStore } from "pinia"
import { fetchDashboardData } from "@/api/dashboard"
// import { fetchProductData } from "@/api/product"
// import { fetchSingleProductData } from "@/api/product"
// import { reset } from "@/api/auth"

export const useAuthStore = defineStore("auth", {
  state: () => ({
    user: null,
    // products: [],
    // singleProduct: null,
    // stat: []
  }),

  actions: {
    async loadUser() {
      const res = await fetchDashboardData()
      this.user = res.data.data.dashboard_data
    },

    // async resetUserPassword(payload) {
    //   try {
    //     const res = await reset(payload)
    //     this.reset = res.data
    //     return res.data // successful response
    //   } catch (error) {
    //     console.error("Failed to Reset:", error)
    //     // important: rethrow so component can catch it
    //     throw error
    //   }
    // },

    logout() {
      localStorage.removeItem("token")
      this.user = null
      this.products = []
      
    }
  }
})
